<template>
  <ExistingItems :items="items" title="Υφιστάμενα Συμπτώματα">
    <template v-slot:item="props">
      <router-link
        :to="{
          name: 'products.symptoms.edit',
          params: { uuid: props.item.uuid },
        }"
      >
        {{ props.item.title }}
      </router-link>
    </template>
  </ExistingItems>
</template>

<script>
import ExistingItems from '@/views/components/ExistingItems';

export default {
  components: {
    ExistingItems,
  },
  props: {
    items: Array,
  },
};
</script>
